module.exports = __webpack_public_path__ + "img/icon6.34bc64e5.svg";